import React from 'react';
import { ListPriceBody } from './ListPriceBody';
import { useFilterController } from '../../../../application/useFilterController';
import { useDebouncedRange } from '../../../hooks/useDebouncedRange';

export const ListPriceDrawerSection = () => {
  const { priceRange, pricePerSqftRange, setPriceRange, setPricePerSqftRange } = useFilterController();

  // reusable range sync (local to store)

  const { minLocal, maxLocal, setMinLocal, setMaxLocal } = useDebouncedRange(priceRange, setPriceRange);
  const { minLocal: minPricePerSqftLocal, maxLocal: maxPricePerSqftLocal, setMinLocal: setMinPricePerSqftLocal, setMaxLocal: setMaxPricePerSqftLocal } = useDebouncedRange(pricePerSqftRange, setPricePerSqftRange);

  // Handle input formatting like before
  const handleMinInput = (v: string) => {
    const n = Number(v.replace(/[^0-9]/g, ''));
    setMinLocal(v ? n : undefined);
  };

  const handleMaxInput = (v: string) => {
    const n = Number(v.replace(/[^0-9]/g, ''));
    setMaxLocal(v ? n : undefined);
  };

  const handleMinPricePerSqftInput = (v: string) => {
    const n = Number(v.replace(/[^0-9]/g, ''));
    setMinPricePerSqftLocal(v ? n : undefined);
  };

  const handleMaxPricePerSqftInput = (v: string) => {
    const n = Number(v.replace(/[^0-9]/g, ''));
    setMaxPricePerSqftLocal(v ? n : undefined);
  };

  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold text-gray-900 pb-2">List Price</h3>
      <div>
        <div className="text-xs text-gray-500 mb-2">Enter a minimum and/or maximum listing price.</div>
        <ListPriceBody
          minLocal={minLocal}
          maxLocal={maxLocal}
          onMinChange={handleMinInput}
          onMaxChange={handleMaxInput}
        />
      </div>

      <div className="pt-4">
        <h3 className="text-lg font-semibold text-gray-900 pb-2">Price per square foot</h3>
        <div className="text-xs text-gray-500 mb-2">Enter a minimum and/or maximum price per square foot.</div>
        <ListPriceBody
          minLocal={minPricePerSqftLocal}
          maxLocal={maxPricePerSqftLocal}
          onMinChange={handleMinPricePerSqftInput}
          onMaxChange={handleMaxPricePerSqftInput}
        />
      </div>

    </div>
  );
};
